// Additive, safe analytics event helper.
// Reuses the existing analytics stack (GA4) IF present via window.gtag / dataLayer.
// No-ops silently if no analytics is configured — does NOT introduce a new stack.
export function track(event, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...params });
    }
  } catch (_) { /* never break UX for analytics */ }
}
